import { numberParser } from '../inboundParsers';
import { seatIndexesParser } from './utils/pokerInboundUtils';
export const START_SEAT_TIMERS_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'seatIndexes', parser: seatIndexesParser },
        { name: 'totalMs', parser: numberParser },
        { name: 'remainingMs', parser: numberParser }
    ]
};
